import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ModalConfirm = ({ show, onHide, data, action }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{data.title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{data.message}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={() => onHide(false)}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={() => action(data.id)}>
          Eliminar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default ModalConfirm;
